import React from 'react';
import Shimmer from './Shimmer';

const StorySectionShimmer = () => {
    const timelineItems = Array(3).fill(null);

    return (
        <section className="py-16">
            <div className="max-w-5xl mx-auto px-4 sm:px-6">
                {/* Titre */}
                <div className="flex justify-center mb-16">
                    <div className="relative overflow-hidden">
                        <Shimmer className="h-10 w-48 rounded"/>
                    </div>
                </div>

                <div className="relative">
                    {/* Timeline line - hidden on mobile */}
                    <div
                        className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#228B22] via-[#228B22]/50 to-transparent"/>

                    <div className="space-y-8 md:space-y-16">
                        {timelineItems.map((_, index) => (
                            <div key={index} className="relative">
                                {/* Timeline dot - hidden on mobile */}
                                <div
                                    className="hidden md:block absolute left-1/2 w-4 h-4 rounded-full bg-slate-900 border-2 border-[#228B22] transform -translate-x-1/2 z-10">
                                    <div className="absolute inset-0 rounded-full animate-ping"/>
                                </div>

                                {/* Content container */}
                                <div className={`flex flex-col md:flex-row ${
                                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                                } gap-4 md:gap-8`}>
                                    {/* Content card */}
                                    <div className={`w-full md:w-1/2 ${
                                        index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'
                                    }`}>
                                        <div
                                            className="backdrop-blur-sm p-6 rounded-xl border">
                                            {/* Header */}
                                            <div className="flex items-center gap-4 mb-4">
                                                <div className="relative overflow-hidden">
                                                    <Shimmer className="h-10 w-10 rounded-lg"/>
                                                </div>
                                                <div className="relative overflow-hidden">
                                                    <Shimmer className="h-7 w-24 rounded-full"/>
                                                </div>
                                            </div>

                                            {/* Content */}
                                            <div className="relative overflow-hidden mb-3">
                                                <Shimmer className="h-7 w-3/4 rounded"/>
                                            </div>
                                            <div className="relative overflow-hidden mb-4">
                                                <Shimmer className="h-4 w-full rounded"/>
                                            </div>
                                            <div className="relative overflow-hidden">
                                                <Shimmer className="h-4 w-2/3 rounded"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StorySectionShimmer;